import { createEntityAdapter } from '@reduxjs/toolkit';
import { FranchiseWithStoresDTO } from '../type';

const franchisesAdapter = createEntityAdapter<FranchiseWithStoresDTO>({
  selectId: franchise => franchise.id || '',
  sortComparer: (a, b) => b.stores.length - a.stores.length,
});

export default franchisesAdapter;
